import {
  getBuildingMembersReport,
  getPackageSubscriptionReports,
  getResidentReports,
  getFutureBookingsReport,
  getProfitReport,
  getPastBookingsReport,
  getDoorHistory,
} from "./ReportsActions";
import { createSlice } from "@reduxjs/toolkit";

interface DashboardState {
  packageSubscriptionReports: any[] | null;
  packageSubscriptionReportsLoading: boolean;
  packageSubscriptionReportsError: any | null;

  residentReports: any[] | null;
  residentReportsLoading: boolean;
  residentReportsError: any | null;

  buildingMembersReport: any[] | null;
  buildingMembersReportLoading: boolean;
  buildingMembersReportError: any | null;

  futureBookingsReport: any[] | null;
  futureBookingsReportLoading: boolean;
  futureBookingsReportError: any | null;

  profitReport: any[] | null;
  profitReportLoading: boolean;
  profitReportError: any | null;

  pastBookingsReport: any[] | null;
  pastBookingsReportLoading: boolean;
  pastBookingsReportError: any | null;

  doorHistory: any[] | null;
  doorHistoryLoading: boolean;
  doorHistoryError: any | null;
}

const initialState: DashboardState = {
  packageSubscriptionReports: null,
  packageSubscriptionReportsLoading: false,
  packageSubscriptionReportsError: null,

  residentReports: null,
  residentReportsLoading: false,
  residentReportsError: null,

  buildingMembersReport: null,
  buildingMembersReportLoading: false,
  buildingMembersReportError: null,

  futureBookingsReport: null,
  futureBookingsReportLoading: false,
  futureBookingsReportError: null,

  profitReport: null,
  profitReportLoading: false,
  profitReportError: null,

  pastBookingsReport: null,
  pastBookingsReportLoading: false,
  pastBookingsReportError: null,

  doorHistory: null,
  doorHistoryLoading: false,
  doorHistoryError: null,
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getPackageSubscriptionReports.pending, (state) => {
      state.packageSubscriptionReportsLoading = true;
      state.packageSubscriptionReportsError = null;
      state.packageSubscriptionReports = null;
    });
    builder.addCase(
      getPackageSubscriptionReports.fulfilled,
      (state, action) => {
        state.packageSubscriptionReports = action.payload;
        state.packageSubscriptionReportsLoading = false;
        state.packageSubscriptionReportsError = null;
      },
    );
    builder.addCase(getPackageSubscriptionReports.rejected, (state, action) => {
      state.packageSubscriptionReportsError = action.payload;
      state.packageSubscriptionReportsLoading = false;
      state.packageSubscriptionReportsError = action.payload;
    });

    builder.addCase(getResidentReports.pending, (state) => {
      state.residentReportsLoading = true;
      state.residentReportsError = null;
      state.residentReports = null;
    });
    builder.addCase(getResidentReports.fulfilled, (state, action) => {
      state.residentReports = action.payload;
      state.residentReportsLoading = false;
      state.residentReportsError = null;
    });
    builder.addCase(getResidentReports.rejected, (state, action) => {
      state.residentReportsError = action.payload;
      state.residentReportsLoading = false;
      state.residentReportsError = action.payload;
    });

    builder.addCase(getBuildingMembersReport.pending, (state) => {
      state.buildingMembersReportLoading = true;
      state.buildingMembersReportError = null;
      state.buildingMembersReport = null;
    });
    builder.addCase(getBuildingMembersReport.fulfilled, (state, action) => {
      state.buildingMembersReport = action.payload;
      state.buildingMembersReportLoading = false;
      state.buildingMembersReportError = null;
    });
    builder.addCase(getBuildingMembersReport.rejected, (state, action) => {
      state.buildingMembersReportError = action.payload;
      state.buildingMembersReportLoading = false;
      state.buildingMembersReportError = action.payload;
    });

    builder.addCase(getFutureBookingsReport.pending, (state) => {
      state.futureBookingsReportLoading = true;
      state.futureBookingsReportError = null;
      state.futureBookingsReport = null;
    });
    builder.addCase(getFutureBookingsReport.fulfilled, (state, action) => {
      state.futureBookingsReport = action.payload;
      state.futureBookingsReportLoading = false;
      state.futureBookingsReportError = null;
    });
    builder.addCase(getFutureBookingsReport.rejected, (state, action) => {
      state.futureBookingsReportError = action.payload;
      state.futureBookingsReportLoading = false;
      state.futureBookingsReportError = action.payload;
    });

    builder.addCase(getProfitReport.pending, (state) => {
      state.profitReportLoading = true;
      state.profitReportError = null;
      state.profitReport = null;
    });
    builder.addCase(getProfitReport.fulfilled, (state, action) => {
      state.profitReport = action.payload;
      state.profitReportLoading = false;
      state.profitReportError = null;
    });
    builder.addCase(getProfitReport.rejected, (state, action) => {
      state.profitReportError = action.payload;
      state.profitReportLoading = false;
      state.profitReportError = action.payload;
    });

    builder.addCase(getPastBookingsReport.pending, (state) => {
      state.pastBookingsReportLoading = true;
      state.pastBookingsReportError = null;
      state.pastBookingsReport = null;
    });
    builder.addCase(getPastBookingsReport.fulfilled, (state, action) => {
      state.pastBookingsReport = action.payload;
      state.pastBookingsReportLoading = false;
      state.pastBookingsReportError = null;
    });
    builder.addCase(getPastBookingsReport.rejected, (state, action) => {
      state.pastBookingsReportError = action.payload;
      state.pastBookingsReportLoading = false;
      state.pastBookingsReport = null;
    });

    builder.addCase(getDoorHistory.pending, (state) => {
      state.doorHistoryLoading = true;
      state.doorHistoryError = null;
      state.doorHistory = null;
    });
    builder.addCase(getDoorHistory.fulfilled, (state, action) => {
      state.doorHistory = action.payload;
      state.doorHistoryLoading = false;
      state.doorHistoryError = null;
    });
    builder.addCase(getDoorHistory.rejected, (state, action) => {
      state.doorHistoryError = action.payload;
      state.doorHistoryLoading = false;
      state.doorHistory = null;
    });
  },
});

const reportsReducer = reportsSlice.reducer;

export default reportsReducer;
